import React, {Fragment, useEffect, useMemo, useRef, useState} from 'react';
import useServiceUrls from "../../Utils/UseServiceUrls";
import useDeviceProfile from "../../Utils/UseDeviceProfile";
import LoadingSpinner from "../LoadingSpinner";
import {
    checkBirthDate, checkValidDate,
    formatDate, getDatePattern,
    getDisplayValue,
    getFullDate, getQueryString,
    handleCartAlerts,
    hasCartIdentifier,
    mapServiceUrls,
    onSnippetComplete,
    completeSnippetOrChainAlerts,
    getReturnUrl,
    copyTextToClipboard,
    sanitizeCustomerName,
} from "../../Helpers/Globals";
import PasswordInput from "../Inputs/PasswordInput";
import EmailInput from "../Inputs/EmailInput";
import TextInput from "../Inputs/TextInput";
import PhoneInput from "../Inputs/PhoneInput";
import {Button} from "@material-ui/core";
import useSignupCustomer from "../../Utils/UseSignupCustomer";
import useSubscriberGroups from "../../Utils/UseSubscriberGroups";
import HeaderWithButtons from "../HeaderWithButtons";
import useSetCartCustomer from "../../Utils/UseSetCartCustomer";
import Header from "../Header";
import CloseIcon from "@mui/icons-material/Close";
import CloseButton from "../PageControls/CloseButton";
import TextInputWithHelpText from "../Inputs/TextInputWithHelpText";
import useResolveCustomer from "../../Utils/UseResolveCustomer";
import FindCustomerModal from "../FindCustomer/FindCustomerModal";
import DuplicateCustomerModal from "./DuplicateCustomerModal";
import DateInputWithHelpText from "../Inputs/DateInputWithHelpText";
import useGetCart from "../../Utils/UseGetCart";
import useAlert from "../../Utils/UseAlert";
import useAcknowledgeAlert from "../../Utils/UseAcknowledgeAlert";
import {client} from "../../Utils/ApiClient";
import {Checkbox, FormControlLabel} from "@mui/material";

export const mapSignupField = (field, index, current, handleChange, loginDomain) => {
    const fieldName = field.FieldName === 'LoyaltyCard' ? 'LoyaltyCardNumber' : field.FieldName
    const label = getDisplayValue(fieldName);
    let inputField;
    switch (fieldName) {
        case 'Password':
            inputField = <>
                <PasswordInput required={field.IsRequired} id={fieldName} value={current} label={label}
                               handleChange={handleChange}/>
            </>;
            break;
        case 'EmailAddress':
            inputField = <EmailInput required={field.IsRequired} id={fieldName} value={current} label={label}
                                     handleChange={handleChange}/>;
            break;
        case 'BirthDate':
            inputField = <TextInputWithHelpText required={field.IsRequired} id={fieldName} value={current} label={label}
                                    handleChange={handleChange} tooltip={'Please enter date in a mm/dd/yyyy format'}/>;
            break;
        case 'MobilePhone':
            inputField = <PhoneInput required={field.IsRequired} id={fieldName} value={current} label={label}
                                    handleChange={handleChange} loginDomain={loginDomain}/>;
            break;
        case 'Country':
            return (
                <Fragment key={index}>
                    {/*<SelectInput current={current} disabled={false} fieldName={field.FieldName} handleChange={handleChange} options={countryOptions}*/}
                    {/*             label={label} required={field.IsRequired}/>*/}
                </Fragment>
            );
        case 'State':
            // if (state.Country === '') {
            //     return;
            // }
            // const selected = countries?.find((curr) => curr.Code === state.Country);
            // if (selected?.HasStates)
            //     return (
            //         <Fragment key={index}>
            //             {/*<SelectInput current={value} disabled={false} fieldName={field.FieldName} handleChange={handleChange}*/}
            //             {/*             options={stateOptions} label={label} required={field.IsRequired}/>*/}
            //         </Fragment>
            //     );
            // else
                inputField = <TextInput required={field.IsRequired} id={fieldName} value={current} label={label}
                                        handleChange={handleChange}/>;

            break;
        default:
            inputField = <TextInput required={field.IsRequired} id={fieldName} value={current} label={label}
                                    handleChange={handleChange}/>;
    }
    return (
        <Fragment key={index}>
            {inputField}
            <br/>
        </Fragment>
    );
};

export default function QuickSignup(props) {
    const { hideHeader = false, onComplete } = props;
    const [sessionKey, setSessionKey] = useState('');
    const [loginDomain, setLoginDomain] = useState('');
    const [cartUid, setCartUid] = useState('');
    const [cartExternalId, setCartExternalId] = useState('');
    const [cartSourceExternalId, setCartSourceExternalId] = useState('');
    const [returnUrl, setReturnUrl] = useState('')
    const [alertUid, setAlertUid] = useState('')
    const { serviceUrlsStatus, serviceUrls, serviceUrlsError } = useServiceUrls(loginDomain);
    const {status, deviceProfile, error} = useDeviceProfile(mapServiceUrls(serviceUrls), sessionKey);
    const {status: groupsStatus, subscriberGroups, error: groupsError} = useSubscriberGroups(serviceUrls, sessionKey)
    const [selectedGroups, setSelectedGroups] = useState([])
    const [signupState, setSignupState] = useState({})
    const [badDate, setBadDate] = useState(false)
    const [badPhone, setBadPhone] = useState(false)
    const [signupComplete, setSignupComplete] = useState(false)
    const [consentGiven, setConsentGiven] = useState(false)
    const [emailConsentGiven, setEmailConsentGiven] = useState(false)
    const [textConsentGiven, setTextConsentGiven] = useState(false)
    const [resolvedCustomer, setResolvedCustomer] = useState(undefined)
    const {status: resolveStatus, resolvedCustomerResponse, error: resolveError, refetch: refetchResolveCustomer} = useResolveCustomer(serviceUrls, sessionKey, signupState)
    const { status: cartStatus, cartResponse, error: cartError, refetch: refetchCart } = useGetCart(serviceUrls, sessionKey, cartUid, cartExternalId, cartSourceExternalId);
    const signup = useSignupCustomer()
    const setCartCustomer = useSetCartCustomer()
    const [allowSignup, setAllowSignup] = useState(true)
    const prevSetCartCustomerStatusRef = useRef(setCartCustomer.status)
    const cartResponseRef = useRef(cartResponse)
    cartResponseRef.current = cartResponse
    const { alert } = useAlert(serviceUrls, sessionKey, alertUid);
    const acknowledgeAlert = useAcknowledgeAlert();
    
    useEffect(() => {
        if (resolvedCustomer === undefined || (deviceProfile.CustomerResolutionRules === undefined || deviceProfile.CustomerResolutionRules === null))
            setAllowSignup(true)
        else {
            let foundMatch = false
            const rules = deviceProfile.CustomerResolutionRules?.Rules.map((rule) => {
                if (rule.Unique && resolvedCustomer[rule.Field] === signupState[rule.Field])
                        foundMatch = true
            })

            setAllowSignup(!foundMatch)
        }
    }, [resolvedCustomer, signupState])

    useEffect(() => {
        setSessionKey(getQueryString(window.location.href, 'bl_sk') ?? getQueryString(window.location.href,'SessionKey') ?? getQueryString(window.location.href, 'sessionKey') ?? '');
        setLoginDomain(getQueryString(window.location.href, 'bl_LoginDomain') ?? getQueryString(window.location.href,'LoginDomain') ?? getQueryString(window.location.href, 'loginDomain') ?? '');
        setReturnUrl(getQueryString(window.location.href, 'bl_rurl') ?? getQueryString(window.location.href,'ReturnUrl') ?? '')
        setCartUid(getQueryString(window.location.href, 'bL_CartUid') ?? getQueryString(window.location.href,'CartUid') ?? getQueryString(window.location.href, 'cartUid') ?? '');
        setCartExternalId(getQueryString(window.location.href, 'bl_CartExternalId') ?? getQueryString(window.location.href,'cartExternalId') ?? '')
        setCartSourceExternalId(getQueryString(window.location.href, 'bl_CartSourceExternalId') ?? getQueryString(window.location.href,'CartSourceExternalId') ?? '')
        setAlertUid(getQueryString(window.location.href, 'bl_alertUid') ?? getQueryString(window.location.href,'alertUid') ?? '')
    }, [window.location.search])
    
    useEffect(() => {
        if (resolveStatus === 'success') {
            if (resolvedCustomerResponse === undefined)
                signup.mutate({
                    urls: serviceUrls,
                    accessKey: sessionKey,
                    customer: getSignupCustomer(),
                    groupsToJoin: selectedGroups
                })
            else
                setResolvedCustomer(resolvedCustomerResponse)
        }
    }, [resolveStatus])
    
    useEffect(() => {
        if (signup.status === 'success') {
            const customer = signup.data.data.Entity
            setCartCustomer.mutate({urls: serviceUrls, cartUid, cartExternalId, cartSourceExternalId, customer, accessKey: sessionKey})
        }
    }, [signup.status])
    
    useEffect(() => {
        if (setCartCustomer.status === 'success' && prevSetCartCustomerStatusRef.current !== 'success') {
            const createdCustomer = signup.data?.data?.Entity;
            if (onComplete !== undefined) {
                if (createdCustomer) {
                    const sanitizedFirstName = sanitizeCustomerName(createdCustomer.FirstName)
                    const sanitizedLastName = sanitizeCustomerName(createdCustomer.LastName)
                    copyTextToClipboard(`${createdCustomer.Code} | ${sanitizedFirstName} ${sanitizedLastName}`)
                }
                onComplete(createdCustomer);
            } else {
                handlePostSignup()
            }
        }
        prevSetCartCustomerStatusRef.current = setCartCustomer.status
    }, [setCartCustomer.status])

    useEffect(() => {
        if (deviceProfile && deviceProfile.SubscriberGroupUids !== undefined) {
            let groups = selectedGroups.slice()
            deviceProfile.SubscriberGroupUids.forEach((g) => groups.push(g))
            setSelectedGroups(groups)
        }
    }, [deviceProfile])
    
    // Initialize consent based on whether it's required
    useEffect(() => {
        if (deviceProfile?.POSSnippetSettings) {
            const requiresConsent = deviceProfile.POSSnippetSettings.ConfirmSubscriberGroupChanges;
            // If consent is not required, default to true so groups are enabled
            if (!requiresConsent) {
                setConsentGiven(true);
            }
        }
    }, [deviceProfile])

    const readSnippetParams = (href = window.location.href) => ({
        sessionKey: getQueryString(href, 'bl_sk') ?? getQueryString(href, 'SessionKey') ?? getQueryString(href, 'sessionKey') ?? '',
        cartUid: getQueryString(href, 'bL_CartUid') ?? getQueryString(href, 'CartUid') ?? getQueryString(href, 'cartUid') ?? '',
        cartExternalId: getQueryString(href, 'bl_CartExternalId') ?? getQueryString(href, 'cartExternalId') ?? '',
        cartSourceExternalId: getQueryString(href, 'bl_CartSourceExternalId') ?? getQueryString(href, 'CartSourceExternalId') ?? '',
        returnUrl: getReturnUrl(href),
    })

    const resolveCartContext = () => {
        const urlParams = readSnippetParams()
        const cart = cartResponseRef.current?.Cart
        return {
            cartUid: cartUid || urlParams.cartUid || cart?.Uid || '',
            cartExternalId: cartExternalId || urlParams.cartExternalId || cart?.ExternalId || '',
            cartSourceExternalId: cartSourceExternalId || urlParams.cartSourceExternalId || cart?.SourceExternalId || '',
            returnUrl: returnUrl || urlParams.returnUrl || '',
        }
    }

    const snippetDone = (resolvedReturnUrl) => {
        onSnippetComplete(resolvedReturnUrl)
        setTimeout(() => setSignupComplete(true), 1000)
    }

    const refetchCartForAlerts = async () => {
        const { cartUid: resolvedCartUid, cartExternalId: resolvedExternalId, cartSourceExternalId: resolvedSourceExternalId } = resolveCartContext()
        const resolvedSessionKey = sessionKey || readSnippetParams().sessionKey

        if (resolvedSessionKey && serviceUrls) {
            const urls = mapServiceUrls(serviceUrls)
            const uniqueParam = new Date().getTime()
            const cartQuery = `${resolvedCartUid ? `cartUid=${resolvedCartUid}&` : ''}${resolvedExternalId ? `externalId=${resolvedExternalId}&` : ''}${resolvedSourceExternalId ? `sourceExternalId=${resolvedSourceExternalId}&` : ''}`
            try {
                return await client(urls.LoyaltyEngineApiUrl, `api/v4/${resolvedSessionKey}/carts?${cartQuery}_=${uniqueParam}`)
            } catch (error) {
                console.log(error)
            }
        }

        const { data } = await refetchCart()
        return data
    }

    const acknowledgeCurrentAlert = async () => {
        const ctx = resolveCartContext()
        const resolvedSessionKey = sessionKey || readSnippetParams().sessionKey
        if (alertUid && hasCartIdentifier(ctx.cartUid, ctx.cartExternalId, ctx.cartSourceExternalId) && serviceUrls && resolvedSessionKey) {
            await acknowledgeAlert.mutateAsync({
                urls: serviceUrls,
                accessKey: resolvedSessionKey,
                cartUid: ctx.cartUid,
                cartExternalId: ctx.cartExternalId,
                cartSourceExternalId: ctx.cartSourceExternalId,
                alertUid
            })
        }
    }

    const finishSnippet = async () => {
        const { returnUrl: resolvedReturnUrl } = resolveCartContext()
        await completeSnippetOrChainAlerts({
            refetchCart: refetchCartForAlerts,
            returnUrl: resolvedReturnUrl,
            onComplete: () => snippetDone(resolvedReturnUrl),
            acknowledgeAlert: acknowledgeCurrentAlert,
        })
    }

    const handlePostSignup = async () => {
        const createdCustomer = signup.data?.data?.Entity;
        if (createdCustomer) {
            const sanitizedFirstName = sanitizeCustomerName(createdCustomer.FirstName)
            const sanitizedLastName = sanitizeCustomerName(createdCustomer.LastName)
            copyTextToClipboard(`${createdCustomer.Code} | ${sanitizedFirstName} ${sanitizedLastName}`)
        }
        await finishSnippet()
    }

    const acknowledgeAlertIfNeeded = () => {
        acknowledgeCurrentAlert().catch(console.log)
    }

    const handleClose = async () => {
        if (onComplete) {
            onComplete()
            return
        }

        await finishSnippet()
    }
    
    const handleChange = (field, value) => {
        setSignupState({
            ...signupState,
            [field]: value
        })
        if (field === 'BirthDate' && badDate)
            setBadDate(false)
        if (field === 'MobilePhone' && badPhone)
            setBadPhone(false)
    }
    
    // Check if login domain requires US formatting (greencross and gxpreprod use non-US)
    const isEnUS = useMemo(() => {
        const domainLower = loginDomain.toLowerCase();
        return domainLower !== 'greencross' && domainLower !== 'gxpreprod';
    }, [loginDomain]);

    const getPhoneErrorMessage = () => {
        return isEnUS 
            ? 'Please enter a valid 10 or 11-digit phone number.'
            : 'Please enter a valid 9 or 10-digit phone number.';
    };

    const isValidPhoneNumber = (phone) => {
        if (!phone) return true; // Empty is valid (unless required)
        // Strip all non-numeric characters for validation
        const numbersOnly = phone.replace(/\D/g, '');
        
        // For US domains: allow 10 or 11 digits
        // For non-US domains (greencross/gxpreprod): allow 9 or 10 digits
        if (isEnUS) {
            return numbersOnly.length === 10 || numbersOnly.length === 11;
        } else {
            return numbersOnly.length === 9 || numbersOnly.length === 10;
        }
    }
    
    const mapSnippetFields = (field, index) => {
        const fieldName = field.FieldName === 'LoyaltyCard' ? 'LoyaltyCardNumber' : field.FieldName
        const current = signupState[fieldName] ?? ''
        return mapSignupField(field, index, current, handleChange, loginDomain)
    }
    
    const toggleGroup = (uid) => {
        // Only require consent if the flag is set
        const requiresConsent = deviceProfile?.POSSnippetSettings?.ConfirmSubscriberGroupChanges;
        if (requiresConsent && !consentGiven) {
            return;
        }
        
        if (selectedGroups.includes(uid)) {
            setSelectedGroups(selectedGroups.filter((g) => g !== uid))
            return;
        }
        
        let groups = selectedGroups.slice()
        groups.push(uid)
        setSelectedGroups(groups)
    }
    
    const mapSubscriberGroup = (group, index) => {
        return <div key={index} className={`quicksignup-subscribergroup ${selectedGroups?.includes(group.Uid) ? 'selected' : ''}`} onClick={() => toggleGroup(group.Uid)}>
            {group.Name}
        </div>
    }

    const getSignupCustomer = () => {
        const customer = { ...signupState }
        const requireEmailConsent = !!deviceProfile?.POSSnippetSettings?.RequireEmailConsent
        const requireTextConsent = !!deviceProfile?.POSSnippetSettings?.RequireTextConsent

        if (requireEmailConsent)
            customer.NoEmail = !emailConsentGiven
        if (requireTextConsent)
            customer.NoTextMessages = !textConsentGiven

        return customer
    }
    
    const submit = (event) => {
        event.preventDefault()
        
        // Validate birth date
        const dateValid = checkValidDate(signupState.BirthDate) || signupState.BirthDate === '';
        if (!dateValid) {
            setBadDate(true);
            return;
        }
        
        // Validate phone numbers if present or required
        if (deviceProfile?.POSSnippetSettings?.QuickSignupFields) {
            const mobilePhoneField = deviceProfile.POSSnippetSettings.QuickSignupFields.find(f => f.FieldName === 'MobilePhone');
            
            const mobilePhoneValue = signupState.MobilePhone || '';
            
            // Validate MobilePhone if it has a value or is required
            if (mobilePhoneValue && !isValidPhoneNumber(mobilePhoneValue)) {
                setBadPhone(true);
                return;
            }
            if (mobilePhoneField?.IsRequired && !mobilePhoneValue) {
                setBadPhone(true);
                return;
            }
        }
        
        acknowledgeAlertIfNeeded()
        refetchResolveCustomer()
    }
    
    const loadExisting = () => {
        setResolvedCustomer(undefined)
        setCartCustomer.mutate({urls: serviceUrls, cartUid, cartExternalId, cartSourceExternalId, customer: resolvedCustomer, accessKey: sessionKey})
    }
    
    const signupAnyway = () => {
        setResolvedCustomer(undefined)
        signup.mutate({
            urls: serviceUrls,
            accessKey: sessionKey,
            customer: getSignupCustomer(),
            groupsToJoin: selectedGroups,
            signupDuplicate: true,
        })
    }


    return (
        <div className={'container'}>
            {status === 'loading' && <LoadingSpinner />}
            {deviceProfile &&
                <>
                    {resolvedCustomer && <DuplicateCustomerModal allowSignup={allowSignup} resolvedCustomer={resolvedCustomer} onCancel={() => setResolvedCustomer(undefined)} loadExisting={loadExisting} signup={signupAnyway} />}
                    {!hideHeader && <Header title={'Quick Signup'}/>}
                    <div className={'snippetContainer center'}>
                        {alert && (
                            <div style={{
                                backgroundColor: '#fff3cd',
                                border: '1px solid #ffc107',
                                borderRadius: '4px',
                                padding: '12px 16px',
                                marginBottom: '20px',
                                fontWeight: 'bold',
                                color: '#856404',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                whiteSpace: 'pre-line'
                            }}>
                                {Array.isArray(alert.Message) ? alert.Message.join('\n') : alert.Message}
                            </div>
                        )}
                        <form onSubmit={submit}>
                            {deviceProfile.POSSnippetSettings.QuickSignupFields.map(mapSnippetFields)}
                            {badDate && <p className='error-text'>Please enter a valid birth date.</p>}
                            {badPhone && <p className='error-text'>{getPhoneErrorMessage()}</p>}
                            {(deviceProfile?.POSSnippetSettings?.RequireEmailConsent ||
                                deviceProfile?.POSSnippetSettings?.RequireTextConsent) && (
                                <div
                                    style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '15px',
                                        width: '100%',
                                        marginTop: '15px',
                                        marginBottom: '15px',
                                    }}
                                >
                                    {deviceProfile?.POSSnippetSettings?.RequireEmailConsent && (
                                        <div
                                            style={{
                                                padding: '12px',
                                                borderRadius: '4px',
                                                border: '1px solid #ccc',
                                                backgroundColor: emailConsentGiven ? '#619700' : '#f5f5f5',
                                                cursor: 'pointer',
                                                transition: 'background-color 0.2s',
                                            }}
                                            onClick={(e) => {
                                                if (e.target === e.currentTarget) {
                                                    setEmailConsentGiven(!emailConsentGiven);
                                                }
                                            }}
                                        >
                                            <div onClick={(e) => e.stopPropagation()}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={emailConsentGiven}
                                                            onChange={(e) => setEmailConsentGiven(e.target.checked)}
                                                            sx={{
                                                                color: emailConsentGiven ? 'white' : '#619700',
                                                                '&.Mui-checked': {
                                                                    color: 'white',
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={
                                                        deviceProfile?.POSSnippetSettings?.EmailConsentText ||
                                                        'Customer agrees to receive emails'
                                                    }
                                                    sx={{
                                                        color: emailConsentGiven ? 'white' : '#333',
                                                        margin: 0,
                                                        userSelect: 'none',
                                                        width: '100%',
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                    {deviceProfile?.POSSnippetSettings?.RequireTextConsent && (
                                        <div
                                            style={{
                                                padding: '12px',
                                                borderRadius: '4px',
                                                border: '1px solid #ccc',
                                                backgroundColor: textConsentGiven ? '#619700' : '#f5f5f5',
                                                cursor: 'pointer',
                                                transition: 'background-color 0.2s',
                                            }}
                                            onClick={(e) => {
                                                if (e.target === e.currentTarget) {
                                                    setTextConsentGiven(!textConsentGiven);
                                                }
                                            }}
                                        >
                                            <div onClick={(e) => e.stopPropagation()}>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox
                                                            checked={textConsentGiven}
                                                            onChange={(e) => setTextConsentGiven(e.target.checked)}
                                                            sx={{
                                                                color: textConsentGiven ? 'white' : '#619700',
                                                                '&.Mui-checked': {
                                                                    color: 'white',
                                                                },
                                                            }}
                                                        />
                                                    }
                                                    label={
                                                        deviceProfile?.POSSnippetSettings?.TextConsentText ||
                                                        'Customer agrees to receive text messages'
                                                    }
                                                    sx={{
                                                        color: textConsentGiven ? 'white' : '#333',
                                                        margin: 0,
                                                        userSelect: 'none',
                                                        width: '100%',
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}
                            <br />
                            {subscriberGroups &&
                                <>
                                    <div>
                                        {subscriberGroups.length > 0 && 
                                        <>
                                        <p className={'bold center'}>Add Customer To Groups</p>
                                        {deviceProfile.POSSnippetSettings.ConfirmSubscriberGroupChanges && 
                                            <div style={{
                                                marginTop: '15px',
                                                marginBottom: '15px',
                                                padding: '12px',
                                                borderRadius: '4px',
                                                border: '1px solid #ccc',
                                                backgroundColor: consentGiven ? '#619700' : '#f5f5f5',
                                                cursor: 'pointer',
                                                transition: 'background-color 0.2s'
                                            }} onClick={(e) => {
                                                // Toggle when clicking on container padding, but not on child elements
                                                if (e.target === e.currentTarget) {
                                                    setConsentGiven(!consentGiven);
                                                }
                                            }}>
                                                <div onClick={(e) => e.stopPropagation()}>
                                                    <FormControlLabel 
                                                        control={
                                                            <Checkbox 
                                                                checked={consentGiven}
                                                                onChange={(e) => setConsentGiven(e.target.checked)}
                                                                sx={{
                                                                    color: consentGiven ? 'white' : '#619700',
                                                                    '&.Mui-checked': {
                                                                        color: 'white'
                                                                    }
                                                                }}
                                                            />
                                                        } 
                                                        label={deviceProfile.POSSnippetSettings.ConfirmSubscriberGroupChangesMessage ? deviceProfile.POSSnippetSettings.ConfirmSubscriberGroupChangesMessage : "Received customer consent to receive subscriber group related Emails and/or Texts"}
                                                        sx={{
                                                            color: consentGiven ? 'white' : '#333',
                                                            margin: 0,
                                                            userSelect: 'none',
                                                            width: '100%'
                                                        }}
                                                    />
                                                </div>
                                            </div>
                                        }
                                        
                                        </>}
                                        <div style={{
                                            marginTop: '25px', 
                                            opacity: (deviceProfile?.POSSnippetSettings?.ConfirmSubscriberGroupChanges && !consentGiven) ? 0.5 : 1, 
                                            pointerEvents: (deviceProfile?.POSSnippetSettings?.ConfirmSubscriberGroupChanges && !consentGiven) ? 'none' : 'auto'
                                        }}>
                                            {subscriberGroups.map(mapSubscriberGroup)}
                                        </div>
                                    </div>
                                    <br />
                                </>
                            }
                            <br />
                            <Button style={{margin: '5px'}} variant={'text'} className={'left'} color={'primary'} onClick={handleClose}>Close</Button>
                            <Button style={{margin: '5px'}} type='submit' className={'right'} variant='contained' color={'primary'} disabled={signup.status === 'loading' || setCartCustomer.status === 'loading' || resolveStatus === 'loading'}>Save</Button>
                            {(signup.status === 'loading' || setCartCustomer.status === 'loading') && <LoadingSpinner />}
                            {signupComplete && <p>Signup is complete and the customer has been set on the cart.</p>}
                            {signup.status === 'error' && <p className='error-text'>{signup.error}</p>}
                            {setCartCustomer.status === 'error' && <p className='error-text'>{setCartCustomer.error}</p>}
                            {serviceUrlsStatus === 'error' && <p className='error-text'>{serviceUrlsError}</p>}
                        </form>
                    </div>
                </>
            }
        </div>
    )
}